<template>
    <div>
        <input-group icon="fa fa-newspaper-o">
            <v-select class='form-control'
                      v-model="selectedOptions"

                      :options="availableOptions"
                      :clearable="true"

                      label='label'

                      :close-on-select="false"
                      multiple
            />
        </input-group>
    </div>
</template>

<script>
import api from "@modules/JourneyBuilder/api";
import {bootstrapDangerGrowl} from "@core/Util/growler";

import VSelect from 'vue-select';
import InputGroup from "@core/Components/Inputs/InputGroup";

export default {
    name: "ProductsSelector",
    components: {
        VSelect,
        InputGroup
    },
    async created() {
        try {
            this.options = await api.getProducts();
        } catch (e) {
            bootstrapDangerGrowl(e);
        }
    },
    computed: {
        selectedOptions: {
            get(){
                return this.options.filter(o => this.value.includes(o.name));
            },
            set(value){
                this.$emit('input', value.map(o => o.name));
            }
        },
        availableOptions(){
            //Only non-selected options should be selectable to avoid confusion
            return this.options.filter(o => !this.value.includes(o.name));
        }
    },
    data() {
        return {
            options: []
        }
    },
    props: {
        value: {
            type: Array,
            required: false,
            default: () => []
        }
    }
}
</script>
